import { Result } from './../types/Result';
import NetworkUtil from "./NetworkUtil";
import {SubmittingProvider} from './../types/SubmittingProvider';

export default class ProviderAPI {

  public static async getAllSubmittingProviders(): Promise<{ success: boolean, reason: string, data: SubmittingProvider[] }> {
    return NetworkUtil.makeGet("/api/admin/providers");
  }

  public static async createProvider(provider): Promise<{ success: boolean, reason: string, contactID:string}> {
    return NetworkUtil.makePost("/api/admin/providers/create", { provider: provider });
  }

  public static async editProvider(provider): Promise<{ success: boolean, reason: string, data:SubmittingProvider }> {
    return NetworkUtil.makePost("/api/admin/providers/edit", { provider: provider });
  }

  public static async filterProviders(filter: { filter: { FullName?, ContactID?, NPI_Number?, FacilityID?} }): Promise<{ success: boolean, reason: string, data: any[] }> {
    return NetworkUtil.makePost("/api/admin/providers/filter", filter);
  }

}